import React from 'react'

import { PageLayout } from '@components/common/PageLayout'
import { HeadContent } from '@fourthwall/components'

import { Analytics } from './modules/Analytics/Analytics'
import { Articles } from './modules/Articles'
import { Events } from './modules/Events/Events'
import { Header } from './modules/Header'
import { Onboarding } from './modules/Onboarding/Onboarding'
import { Suggestions } from './modules/Suggestions'
import { Video } from './modules/Video'
import { OverviewProvider } from './providers/OverviewProvider'
import * as S from './styled'

export const Overview = () => (
  <OverviewProvider>
    <HeadContent title="Memberships overview" />
    <PageLayout>
      <Header />
      <S.Container>
        <Video />
        <Onboarding />
        <Analytics />
        <Events />
        <Suggestions />
        <Articles />
      </S.Container>
    </PageLayout>
  </OverviewProvider>
)
